export const routesAnket = [
  {
    path: "/anket-personel/admin/liste",
    name: "anket-personel-admin-liste",
    component: () => import("@/views/anket_personel/admin/List.vue"),
    meta: {
      public: false,
      title: "Anket Listesi",
      yetki: { k: [1100002] },
    },
  },
  {
    path: "/anket-personel/admin/olustur",
    name: "anket-personel-admin-olustur",
    component: () => import("@/views/anket_personel/admin/Create.vue"),
    meta: {
      public: false,
      title: "Yeni Anket Oluştur",
      yetki: { k: [1100002] },
    },
  },
  {
    path: "/anket-personel/admin/duzenle/:id",
    name: "anket-personel-admin-duzenle",
    component: () => import("@/views/anket_personel/admin/Edit.vue"),
    meta: {
      public: false,
      title: "Anketi Düzenle",
      yetki: { k: [1100002] },
    },
  },
  {
    path: "/anket-personel/admin/sonuclar/:id",
    name: "anket-personel-admin-sonuclar",
    component: () => import("@/views/anket_personel/admin/Results.vue"),
    meta: {
      public: false,
      title: "Anket Sonuçları",
      yetki: { k: [1100002] },
    },
  },
  {
    path: "/anket-personel/admin/cevaplar/:id",
    name: "anket-personel-admin-cevaplar",
    component: () => import("@/views/anket_personel/admin/Responses.vue"),
    meta: {
      public: false,
      title: "Anket Cevapları",
      yetki: { k: [1100002] },
    },
  },
  {
    path: "/anket-personel/user/liste",
    name: "anket-personel-user-liste",
    component: () => import("@/views/anket_personel/user/List.vue"),
    meta: {
      public: false,
      title: "Anket Listesi",
      yetki: { k: [1100102] },
    },
  },
  {
    path: "/anket-personel/user/coz/:uuid",
    name: "anket-personel-user-coz",
    component: () => import("@/views/anket_personel/user/Solve.vue"),
    meta: {
      public: false,
      title: "Anketi Çöz",
      yetki: { k: [1100102] },

      // layout: 'blank'
    },
  },
]
